module.exports = {"511823100":"富林镇","511823101":"九襄镇","511823102":"乌斯河镇","511823103":"宜东镇","511823104":"富庄镇","511823105":"清溪镇","511823106":"大树镇","511823107":"皇木镇","511823108":"唐家镇","511823109":"富泉镇","511823200":"大田乡","511823203":"河西乡","511823205":"前域乡","511823206":"后域乡","511823209":"富乡乡","511823210":"梨园乡","511823211":"三交乡","511823212":"双溪乡","511823213":"西溪乡","511823218":"安乐乡","511823219":"万里乡","511823220":"马烈乡","511823224":"河南乡","511823225":"晒经乡","511823226":"料林乡","511823227":"小堡藏族彝族乡","511823228":"片马彝族乡","511823229":"坭美彝族乡","511823230":"永利彝族乡","511823231":"顺河彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511823.json
// module id = 2198
// module chunks = 0